import PropTypes from 'prop-types';
import { defaultProps, propTypes } from './propTypes';
import WithImage from './components/WithImage';

const EpisodePreviewSmall = ({
  type,
  ...propsToPass
}) => {
  return (
    <WithImage { ...propsToPass } />
  );
};

EpisodePreviewSmall.propTypes = {
  type: PropTypes.string,
  ...propTypes
};

EpisodePreviewSmall.defaultProps = {
  type: 'image',
  ...defaultProps
};

export default EpisodePreviewSmall;